import React, { useState } from "react";

import EcoSegmented from "../../../components/eco-ui/EcoSegmented";
import EcoSymbol from "../../../img/eco/simbolo.png";
import { AD_IDENTITY } from "../campanhasApi";

export type MockPlacement = "facebook" | "instagram" | "stories";

const PLACEMENTS: { value: MockPlacement; label: string }[] = [
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "stories", label: "Stories" },
];

type Props = {
  primaryText: string;
  headline: string;
  description: string;
  /** Imagem escolhida (object URL) ou a já gravada. */
  imageUrl: string | null;
  /** Domínio que aparece embaixo da imagem no Facebook. */
  domain?: string;
};

/**
 * Prévia SIMULADA do anúncio, desenhada aqui para atualizar enquanto se digita.
 * É aproximada (o corte e o "Ver mais" da Meta podem variar um pouco); a prévia
 * oficial fica na tela da campanha.
 */
const AdPreviewMock: React.FC<Props> = ({ primaryText, headline, description, imageUrl, domain = "ecosystem.app" }) => {
  const [placement, setPlacement] = useState<MockPlacement>("facebook");
  const [expanded, setExpanded] = useState(false);
  const text = primaryText.trim() || "Texto principal do anúncio";
  const title = headline.trim() || "Título";
  const long = text.length > 125;
  const shown = expanded || !long ? text : `${text.slice(0, 125).trimEnd()}…`;

  const image = imageUrl ? (
    <img className="adMock__image" src={imageUrl} alt="" />
  ) : (
    <div className="adMock__image adMock__image--empty">Imagem do anúncio</div>
  );

  return (
    <div className="adMock">
      <EcoSegmented label="Onde" options={PLACEMENTS} value={placement} onChange={setPlacement} />

      {placement === "facebook" ? (
        <article className="adMock__phone adMock__fb" aria-label="Prévia no feed do Facebook">
          <header className="adMock__head">
            <img className="adMock__avatar" src={EcoSymbol} alt="" />
            <span>
              <strong>{AD_IDENTITY.pageName}</strong>
              <small>Patrocinado · 🌐</small>
            </span>
          </header>
          <p className="adMock__text">
            {shown}
            {long ? (
              <button type="button" className="adMock__more" onClick={() => setExpanded((v) => !v)}>
                {expanded ? " Ver menos" : " Ver mais"}
              </button>
            ) : null}
          </p>
          {image}
          <footer className="adMock__link">
            <span className="adMock__linkText">
              <small>{domain.toUpperCase()}</small>
              <strong>{title}</strong>
              {description.trim() ? <small>{description.trim()}</small> : null}
            </span>
            <span className="adMock__cta">Candidatar-se</span>
          </footer>
          <div className="adMock__actions" aria-hidden="true">
            <span>👍 Curtir</span>
            <span>💬 Comentar</span>
            <span>↗ Compartilhar</span>
          </div>
        </article>
      ) : null}

      {placement === "instagram" ? (
        <article className="adMock__phone adMock__ig" aria-label="Prévia no feed do Instagram">
          <header className="adMock__head">
            <img className="adMock__avatar adMock__avatar--ring" src={EcoSymbol} alt="" />
            <span>
              <strong>{AD_IDENTITY.instagram}</strong>
              <small>Patrocinado</small>
            </span>
          </header>
          {image}
          <div className="adMock__igCta">
            <span>Candidatar-se</span>
            <span aria-hidden="true">›</span>
          </div>
          <div className="adMock__icons" aria-hidden="true">
            ♡ &nbsp; 💬 &nbsp; ↗
          </div>
          <p className="adMock__text adMock__text--ig">
            <strong>{AD_IDENTITY.instagram}</strong> {expanded || text.length <= 90 ? text : `${text.slice(0, 90).trimEnd()}…`}
            {text.length > 90 ? (
              <button type="button" className="adMock__more" onClick={() => setExpanded((v) => !v)}>
                {expanded ? " menos" : " mais"}
              </button>
            ) : null}
          </p>
        </article>
      ) : null}

      {placement === "stories" ? (
        <article className="adMock__phone adMock__story" aria-label="Prévia nos stories">
          {imageUrl ? <img className="adMock__storyBg" src={imageUrl} alt="" /> : <div className="adMock__storyBg adMock__image--empty" />}
          <div className="adMock__storyTop">
            <span className="adMock__storyBar" />
            <span className="adMock__storyWho">
              <img className="adMock__avatar" src={EcoSymbol} alt="" />
              <strong>{AD_IDENTITY.instagram}</strong>
              <small>Patrocinado</small>
            </span>
          </div>
          <div className="adMock__storyBottom">
            <p>{text.length > 110 ? `${text.slice(0, 110).trimEnd()}…` : text}</p>
            <span className="adMock__storyCta">⌃ Candidatar-se</span>
          </div>
        </article>
      ) : null}

      <p className="cmpHint">Prévia simulada: o corte da imagem e o "Ver mais" da Meta podem variar um pouco. A prévia oficial fica no anúncio salvo.</p>
    </div>
  );
};

export default AdPreviewMock;
